// Returns the best URL to display a business:
// - active custom domain (Premium): https://<domain>/
// - businesses with a subdomain: dedicated landing at <sub>.lokalnie.pro
// - otherwise: fallback catalog page /firma/<id>
//
// Returned object distinguishes external (absolute URL) vs internal (path).
// Callers should render <a href> for external and <Link to> for internal.
export function businessUrl(business) {
  if (business?.custom_domain && business?.custom_domain_status === "active") {
    return { external: true, url: `https://${business.custom_domain}/` };
  }
  if (business?.subdomain) {
    const host = typeof window !== "undefined" ? window.location.hostname : "lokalnie.dev.sorto.ai";
    const APEX_HOSTS = ["lokalnie.pro", "lokalnie.dev.sorto.ai"];
    const apex = APEX_HOSTS.find((a) => host === a || host.endsWith(`.${a}`)) || "lokalnie.dev.sorto.ai";
    return { external: true, url: `https://${business.subdomain}.${apex}/` };
  }
  return { external: false, url: `/firma/${business.business_id}` };
}
